var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-scroll h100-80"},[_c('div',{staticClass:"h-topo-tree"},[_c('ejs-treeview',{ref:"PmNoRealTaskLeftTreeForResource",attrs:{"nodeSelected":_vm.nodeSelectedOfResourceTreeForTask,"fields":_vm.fieldsOfResourceTreeForTask}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }